/* Onglets de la boutique (bloc 8). Change la grille sans rechargement.
   Les trois panneaux sont rendus par Liquid : le basculement est un simple
   jeu d'attributs, aucun appel réseau, et la page reste lisible sans JS
   (le premier panneau est visible, les autres sont `hidden`). */
/* La page d'accueil pose deux fois cette section — les onglets de la
   boutique et les dernières box en stock — donc deux balises script
   identiques et deux exécutions. Sans cette portée locale, la seconde
   lançait « Identifier 'ShopTabs' has already been declared ». */
(() => {
class ShopTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });

    // Dans l'éditeur de thème, sélectionner un bloc onglet l'ouvre.
    document.addEventListener('shopify:block:select', (event) => {
      const tab = this.tabs.find((t) => t.id === `tab-${event.detail.sectionId}-${event.detail.blockId}`);
      if (tab) this.select(tab, false);
    });
  }

  select(tab, focus = true) {
    this.tabs.forEach((item) => {
      const isTarget = item === tab;
      item.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      item.setAttribute('tabindex', isTarget ? '0' : '-1');
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.toggleAttribute('hidden', !isTarget);
    });
    if (focus) tab.focus();
  }

  onKeydown(event) {
    const index = this.tabs.indexOf(event.target);
    if (index === -1) return;
    let next = null;
    if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
    if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
    if (event.key === 'Home') next = this.tabs[0];
    if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    this.select(next);
  }
}

if (!customElements.get('shop-tabs')) customElements.define('shop-tabs', ShopTabs);
})();
